import React, { useState } from "react";
import PropTypes from 'prop-types'
import { AcceptButton, MeasureOpacity, Highlighted, Text, ButtonWrapper } from './theme'
import Drawer from './../Drawer'
import Modal from "react-modal";
import { Button } from "../../containers/NewProjectForm/theme";

const ModalMes = ({modalIsOpen, closeModal, real}) => {
  const [mes, setMes] = useState(real)

  const change = (e) => setMes(e.currentTarget.value)

  const close = () => {
    closeModal(mes)
  }

  return (<Modal
    isOpen={modalIsOpen}
    onRequestClose={close}
    style={{
      content: {
        top: '-30%'
      },
      overlay: {
        zIndex: 10000
      }
    }}
    contentLabel="Example Modal"
  >
    <h3>Jaka odległość jest zaznaczona? ( {real? real:0}cm )</h3>
    <input style={{height: '32px', width: '100%', margin: '10px 0px 20px 0px'}} type={'number'} value={mes} onChange={change}/>
    <Button onClick={close}>OK</Button>
  </Modal>)
}

const MeasureBackground = ({
  index,
  measurement: { perMeter, realMeter } = { perMeter: 0, realMeter: 100 },
  changeMeasurement,
  accept,
  isCalibrationNow, sidebarIsClosed,
  changeRealMeter,
}) => {
  const [open, setOpen] = useState(false)

  const openModal = () =>
    setOpen(true)

  const closeModal = mes => {
    setOpen(false)
    changeRealMeter(index, mes)()
  }

  const change = (index, perMeter) => {
    changeMeasurement(index, (perMeter/(realMeter | 100))*100)
  }

  return (
    <MeasureOpacity isCalibrationNow={isCalibrationNow} isFull={sidebarIsClosed}>
    <Drawer index={index} changeMeasurement={change} sidebarIsClosed={sidebarIsClosed} />

    <Text sidebar={sidebarIsClosed} nonInteractive={true}>
      <Highlighted>1.</Highlighted> Przeciągnij myszką między charakterystycznymi punktami na zdjęciu (np. Krawędziami
      fotela, itp.)
      <br />
      Obiekt powinien być ustawiony pod ścianą.
      <br />
      <Highlighted>2.</Highlighted> Zmierz za pomocą linijki lub taśmy mierniczej tę odległość w rzeczywistości.
      <br />
      <Highlighted>3.</Highlighted> Wpisz <Highlighted>zmierzoną odległość</Highlighted> w okienku w centymetrach.
      <br />
      <Highlighted>4.</Highlighted> Kliknij <Highlighted>Zaakceptuj kalibrację.</Highlighted>
      <br />
    </Text>

    <ButtonWrapper sidebar={sidebarIsClosed} nonInteractive={true}>
      <AcceptButton onClick={openModal}>
        Zmierzona odległość: {realMeter || 100}
        cm
      </AcceptButton>
      <AcceptButton disabled={perMeter === 0} onClick={accept}>
        Zaakceptuj kalibrację
      </AcceptButton>
    </ButtonWrapper>
      <ModalMes modalIsOpen={open} closeModal={closeModal} real={realMeter}/>
  </MeasureOpacity>
)}

MeasureBackground.propTypes = {
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  measurement: PropTypes.shape({
    perMeter: PropTypes.number,
    realMeter: PropTypes.number,
  }).isRequired,
  changeMeasurement: PropTypes.func.isRequired,
  changeRealMeter: PropTypes.func.isRequired,
  accept: PropTypes.func.isRequired,
  isCalibrationNow: PropTypes.bool.isRequired,
  sidebarIsClosed: PropTypes.bool.isRequired,
}

export default MeasureBackground



// WEBPACK FOOTER //
// ./src/components/MeasureBackground/index.js